import { render, staticRenderFns } from "./UsersForAppt.vue?vue&type=template&id=52a1d9dd&scoped=true"
import script from "./UsersForAppt.vue?vue&type=script&lang=js"
export * from "./UsersForAppt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a1d9dd",
  null
  
)

export default component.exports